import styled from 'styled-components';

import { IToast } from './Toast';

interface TWrapper {
  direction: IToast.TDirection;
}

export const SnackWrapper = styled.div<TWrapper>`
  padding: 15px;
  position: fixed;
  width: auto;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  bottom: 0;
  ${({ direction }) => (direction === 'left' ? 'left: 0' : 'right: 0')};
  z-index: 999;
`;
